import {
    ADDITIONAL_PAGE_OPTIONS,
    RedplusTariff,
} from '@vfde-sails/constants';
import { InitialState } from 'Container/App/interface';
import {
    createSlice,
    PayloadAction,
} from '@reduxjs/toolkit';

/**
 * Initial state
 */
const initialState: InitialState = {
    availableSubscriptionIds: [],
    customerConfig: {
        flow: window[ADDITIONAL_PAGE_OPTIONS].flow,
        salesChannel: window[ADDITIONAL_PAGE_OPTIONS].salesChannel,
        selectedRedplusId: null,
        atomicId: null,
        activeSubscriptionId: null,
        isXSellEligible: false,
        hasCashback: false,
    },
};

const redPlusSlice = createSlice({
    name: 'Red+',
    initialState,
    reducers: {
        setInitialState: {
            reducer: (
                draft,
                action: PayloadAction<{ availableSubscriptionIds: RedplusTariff[]; customerConfig: InitialState['customerConfig'] }>,
            ) => {
                draft.customerConfig = action.payload.customerConfig;
                draft.availableSubscriptionIds = action.payload.availableSubscriptionIds;
            },
            prepare: (
                availableSubscriptionIds: RedplusTariff[],
                customerConfig: InitialState['customerConfig'] = {
                    flow: window[ADDITIONAL_PAGE_OPTIONS].flow,
                    salesChannel: window[ADDITIONAL_PAGE_OPTIONS].salesChannel,
                    selectedRedplusId: null,
                    atomicId: null,
                    activeSubscriptionId: null,
                    isXSellEligible: false,
                    hasCashback: false,
                },
            ) => ({
                payload: {
                    availableSubscriptionIds,
                    customerConfig,
                },
            }),
        },
        goToBasket: {
            reducer: (draft, action: PayloadAction<{ selectedRedPlusId: RedplusTariff; withRedPlus?: boolean }>) => {
                draft.customerConfig.selectedRedplusId = action.payload.selectedRedPlusId;
            },
            prepare: (selectedRedPlusId: RedplusTariff, withRedPlus?: boolean) => ({
                payload: {
                    selectedRedPlusId,
                    withRedPlus,
                },
            }),
        },
        goToDeviceSelection: (state, action: PayloadAction<RedplusTariff>) => {
            state.customerConfig.selectedRedplusId = action.payload;
        },
        setCashback: (state, action: PayloadAction<boolean>) => {
            state.customerConfig.hasCashback = action.payload;
        },
    },
    selectors: {
        selectAvailableSubscriptionIds: state => state.availableSubscriptionIds,
        selectCustomerConfig: state => state.customerConfig,
    },
});

export const {
    setInitialState,
    goToBasket,
    goToDeviceSelection,
    setCashback,
} = redPlusSlice.actions;

export const {
    selectAvailableSubscriptionIds,
    selectCustomerConfig,
} = redPlusSlice.selectors;

/**
 * Action Dispatchers
 */
export type ActionDispatchers = Pick<typeof redPlusSlice.actions, 'setInitialState' | 'goToBasket' | 'goToDeviceSelection'>
export default redPlusSlice;
